<ion-card class="ionCard--white ionCard--white__noshadow qb-error">
  <ion-icon
    class="modal__close verti-close-16"
    (click)="dismiss()"
    (keyup.enter)="dismiss()"
    tabindex="0"
    [attr.aria-label]="closeIconAriaLabel"
  ></ion-icon>
  <ion-card-header class="ionCard__header__no_separator">
    <ion-card-title
      class="exit__title"
      [innerHTML]="'OFFER.PROMO_CODE.TITLE' | translate | qbItaSafeHtml"
    ></ion-card-title>
  </ion-card-header>

  <ion-card-content class="content">
    <form class="offer__form" [formGroup]="promoCodeForm">
      <qb-ita-input
        formControlName="promoCode"
        [label]="'OFFER.INPUTS.PROMO_CODE.LABEL' | translate"
        maxlength="20"
        type="text"
        [error]="promoCodeError"
      />
    </form>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <qb-ita-button
            buttonPosition="center"
            [label]="'OFFER.PROMO_CODE.CONTINUE_BUTTON.TITLE' | translate"
            (btnClick)="onButtonClicked()"
            [disabled]="promoCodeForm.invalid"
            [showSpinner]="false"
          />
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <qb-ita-button
            color="secondary"
            buttonPosition="center"
            [label]="'CANCEL_BUTTON.TITLE' | translate"
            (btnClick)="dismiss()"
            [showSpinner]="false"
          />
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
